import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  blueMenu: {
    backgroundColor: theme.palette.secondary.main,
    maxWidth: '98%',
    marginLeft: theme.spacing(1),
  },
  tabWidth: {
    width: '50%',
  },
  panel: {
    [`& div`]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  withMargins: {
    margin: theme.spacing(1),
    [`& fieldset`]: {
      borderRadius: 0,
    },
  },
  fullWidth: {
    width: '100%',
  },
  tabWidthOption: {
    width: '48%',
    display: 'inline-block',
    verticalAlign: 'top',
    minHeight: '336px',
  },
  btn: {
    margin: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  checkBoxWrapper: {
    paddingLeft: `8px !important`,
    [`& label`]: {
      [`& span`]: {
        fontSize: '0.9rem',
      },
    },
  },
  indicator: {
    backgroundColor: 'white',
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`cardFormats-tabpanel-${index}`}
      aria-labelledby={`cardFormats-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function cardFormatsProps(index) {
  return {
    id: `cardFormats-tab-${index}`,
    'aria-controls': `cardFormats-tabpanel-${index}`,
  };
}

function CardFormatsTab(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div>
      <AppBar position="static" className={classes.blueMenu}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="Card Format(s) Tabs"
          classes={{
            indicator: classes.indicator,
          }}
        >
          <Tab label="Format Options" {...cardFormatsProps(0)} />
          <Tab label="Card Options" {...cardFormatsProps(1)} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0} className={classes.panel}>
        {props.formatTabDetails.formatOptions.map((item) => (
          <FormControl className={classes.tabWidth} key={item.id}>
            <TextField
              size="small"
              className={classes.withMargins}
              value={item.value}
              label={item.labelName}
              variant="outlined"
            />
          </FormControl>
        ))}
      </TabPanel>
      <TabPanel value={value} index={1} className={classes.panel}>
        <div className={classes.tabWidthOption}>
          {props.formatTabDetails.cardOptions.map((item) => (
            <div className={classes.checkBoxWrapper}>
              <FormControlLabel
                key={item.id}
                control={<Checkbox checked={item.checked} name="" color="secondary" />}
                label={item.labelName}
                value={item.value}
              />
            </div>
          ))}
        </div>

        <div className={classes.tabWidthOption}>
          {props.formatTabDetails.idoffset.map((item) => (
            <TextField
              size="small"
              className={`${classes.withMargins} ${classes.fullWidth}`}
              value={item.value}
              label={item.labelName}
              variant="outlined"
            />
          ))}
        </div>
      </TabPanel>
      <div style={{ float: 'right' }}>
        <Button className={classes.btn}>Cancel</Button>
        <Button variant="contained" color="secondary" className={classes.btn}>
          Save
        </Button>
      </div>
    </div>
  );
}

export default CardFormatsTab;
